import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { Box, Button, Stack } from '@src/components';

import useAbsencesTimeline from '../../../hooks';

function getDayNumbersInMonth(year, monthIndex) {
  const days = new Date(year, monthIndex + 1, 0).getDate();
  return Array.from({ length: days }, (_, i) => i + 1);
}

export default function DaysListSwitcher({ currentDates}) {
  const year = currentDates.start.getFullYear();
  const activeMonth = currentDates.start.getMonth();
  const activeDay = currentDates.start.getDate();
  const days = getDayNumbersInMonth(year, activeMonth);
  const { calendar } = useAbsencesTimeline();

  const onNext = () => calendar.next();
  const onPrev = () => calendar.prev();
  const onGotoDate = (year, month, date) => {
    calendar.gotoDate(new Date(year, month, date));
  };

  return (
    <Box
      sx={StyleSheet.container}
    >
      <Button
        sx={StyleSheet.control}
        onClick={onPrev}
        startIcon={<ArrowBackIosNewIcon fontSize="small" />}
      />

      <Stack spacing={1}sx={StyleSheet.monthContainer} direction="row" justifyContent="space-between">
        {days.map((d, i) => {
          const isDayActive = d === activeDay;
          return (
            <Button
              key={i}
              sx={StyleSheet.day(isDayActive)}
              onClick={() => onGotoDate(year, activeMonth, d)}
            >
              {d}
            </Button>
          );
        })}
      </Stack>


      <Button
        sx={StyleSheet.control}
        onClick={onNext}
        endIcon={<ArrowForwardIosIcon fontSize="small" />}
      />
    </Box>
  );
}

const StyleSheet = {
  container: (theme) => ({
    background: theme.palette.grey[600],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 15px',
  }),
  control: (theme) => ({
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
      fill: theme.palette.common.white,
    },
    padding: 0,
    minWidth: '20px',
  }),
  separator: (isActive) => (theme) => ({
    fontSize: '36px',
    padding: 0,
    minWidth: '10px',
    margin: 0,
    color: isActive ? theme.palette.common.white : theme.palette.grey[300],
  }),
  monthContainer: {
    width: '100%',
  },
  day: (isActive) => (theme) => ({
    color: isActive ? theme.palette.common.white : theme.palette.grey[300],
    fontSize: isActive ? '16px' : '14px',
    fontWeight: isActive ? 900 : 600,
    minWidth: '20px',
    padding: 0,
  }),
};
